const colors: Record<string, any> = {
  aerospace: '#FF5100',
  white: '#FFFFFF',
  black: '#000000',
  chineseBlack: '#121212',
  eerieBlack: '#1B1B1B',
  raisinBlack: '#262626',
  cyan: '#00B2E3',

  darkBlue: '#292935',
  darkGoku: '#19191C',
  greyText: '#999999',
  primaryRed: '#F73535',
  primaryBrown: '#231F20',
  primaryBlue: '#316EF7',
  activeBlue: '#88B3FF',
  secondaryBlue: '#535374',
  OlybetSecondaryBlue: '#33CFFF',

  gradientOlybet: 'linear-gradient(279deg, #F73535 13.3%, #33CFFF 86.79%)',

  input: {
    bg: '#3B3B54',
    border: '#88B3FF',
    text: '#FFFFFF',
    placeholder: '#8A8AB2',
    invalid: '#E22F2F',
    cancel: '#D9D9D9',
    hint: '#D9D9D9',
    success: '#009656',
    eye: '#D9D9D9',
  },
};

export default colors;
